<template>
  <div class="mb-3">
    <div v-if="loading" class="row">
      <div class="col-12">
        <div class="text-center text-primary my-2">
          <b-spinner type="grow" class="align-middle"></b-spinner>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-lg-4">
          <div class="row">
            <div
              class="col-12"
              v-if="userProfile.permissions.treatments.enableResponsible"
            >
              <idx-card
                :title="`${this.$t(
                  'answers.answersDetails.treatments.changeResponsible',
                )}`"
              >
                <p>
                  {{ $t('answers.answersDetails.treatments.responsible') }}:
                </p>
                <div
                  style="position: absolute; right: 40px; top: 65px"
                  v-if="isSinqia"
                >
                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="switch-monitor"
                        v-model="oneAnswer.treatments.enableMonitor"
                      />
                      <label class="custom-control-label" for="switch-monitor"
                        >Monitorar tratativa
                      </label>
                      <font-awesome-icon
                        :icon="['fas', 'info-circle']"
                        style="font-size: 15px; color: #c1c1c1"
                        title="Envia notificações por email ao responsável sobre alterações desta tratativa."
                      />
                    </div>
                  </div>
                </div>
                <b-form-select
                  style="font-weight: bold; background-color: #CAF8E0"
                  v-model="myResponsible"
                  :responsible="myResponsible"
                  :options="users"
                  @change="changeResponsible"
                  :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado' || myStatus === 'Resp. fora do prazo'"
                >
                </b-form-select>
              </idx-card>
            </div>
          </div>
          <div class="row mt-4 mb-4">
            <div class="col-12">
              <idx-card
                :title="`${this.$t(
                  'answers.answersDetails.treatments.addCommentary',
                )}`"
              >
                <b-alert class="mt-3" v-if="isSinqia" variant="danger" show
                  >Atenção!! Não deixe de escrever a causa da insatisfação e o
                  plano de ação.</b-alert
                >
                <div
                  v-if="userProfile.permissions.treatments.enableComment"
                  class="comment-area"
                >
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="myComment"
                    :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado' || myStatus === 'Resp. fora do prazo'"
                  />
                  <!-- <button
                    @click="addNewComment"
                    class="btn btn-primary ml-1"
                    :disabled="myStatus === 'respondido'"
                  >
                    <font-awesome-icon :icon="['fas', 'paper-plane']" />
                  </button> -->
                </div>

                <!-- Enables if the company has upload permission in the negotiation (config master) and if the user is allowed to view (config user permission) -->
                <div
                  class="mt-2 file-custom"
                  v-if="
                    enabledAttach &&
                    userProfile.permissions.treatments.enableAttachment
                  "
                >
                  <b-list-group class="mb-2">
                    <b-list-group-item
                      v-for="(item, index) in filesToUpload"
                      :key="item.name"
                    >
                      <font-awesome-icon
                        style="color: #777777"
                        :icon="['fas', 'paperclip']"
                      />
                      {{ item.name.substring(0, 40) + '...' }}
                      <font-awesome-icon
                        class="float-right"
                        style="color: red"
                        @click="removeFile(index)"
                        :icon="['fas', 'times-circle']"
                      />
                    </b-list-group-item>
                  </b-list-group>
                  <div class="text-center" v-if="isLoading">
                    <b-spinner variant="primary" label=""></b-spinner>
                  </div>
                  <label
                    style="
                      font-weight: bold;
                      font-size: 15px;
                      margin-bottom: 10px;
                    "
                    for="selectFile"
                    v-if="!isLoading"
                  >
                    {{ $t('uploads.attachFile') }}:
                  </label>
                  <hr style="margin-top: 3px" />
                  <b-form-file
                    v-if="!isLoading"
                    :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado' || myStatus === 'Resp. fora do prazo'"
                    multiple
                    :placeholder="$t('uploads.attachFile')"
                    :browse-text="$t('uploads.selectLabel')"
                    :drop-placeholder="$t('uploads.dropPlaceholder')"
                    id="selectFile"
                    ref="fileupload"
                    v-model="filesToUpload"
                    style="margin-top: 4px"
                  >
                  </b-form-file>
                </div>
                <div
                  v-if="userProfile.permissions.treatments.treatmentCategory"
                  class="row mt-4 mb-4"
                >
                  <div class="col-12">
                    <p
                      style="
                        font-weight: bold;
                        font-size: 15px;
                        margin-bottom: 3px;
                      "
                    >
                      {{ $t('tagsTreatmenTranslateUpdate.title') }}
                    </p>
                    <hr style="margin-top: 12px" />
                    <div>
                      <b-dropdown
                        size="xl"
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                        dropright
                        id="dropdown-tag"
                        style="margin-top: -14px"
                      >
                        <template v-slot:button-content>
                          <div style="display: flex">
                            <template v-if="myStatus !== 'respondido' && myStatus !== 'Resp. fora do prazo'">
                              <p style="font-size: 18px">
                                {{ $t('tagsTreatmenTranslateUpdate.addTag') }}
                              </p>
                              <font-awesome-icon
                                :icon="['fas', 'plus-circle']"
                                class="text-primary"
                                style="
                                  cursor: pointer;
                                  margin-top: 8px;
                                  margin-left: 5px;
                                "
                              />
                              <span class="sr-only">
                                {{ $t('treatments.searchDropdown') }}
                              </span>
                            </template>
                          </div>
                        </template>

                        <div style="width: 400px">
                          <input
                            class="input-search-tags"
                            v-model="tagSearch"
                          />
                          <button
                            @click="tagSearch = ''"
                            class="btn btn-outline-primary icon-eraser-tag"
                          >
                            <i title="Limpar" class="fas fa-eraser"></i>
                          </button>
                        </div>

                        <div
                          v-if="options.length !== 0"
                          style="max-height: 300px; overflow-y: scroll"
                        >
                          <b-dropdown-text style="margin-left: -35px">
                            <ul
                              v-for="(option, i) in tagsList"
                              :key="i"
                              style="font-size: 20px; list-style: none"
                            >
                              <li>
                                <i
                                  @click="showSubTags($event, option._id, i)"
                                  :class="
                                    option.displaySubTags
                                      ? 'fas fa-caret-down'
                                      : 'fas fa-caret-right'
                                  "
                                />

                                <input
                                  @click="handleTagClick($event, option._id)"
                                  style="zoom: 1.4"
                                  type="checkbox"
                                  :value="option._id"
                                  :id="`${i}`"
                                  :name="`${i}`"
                                  :checked="
                                    oneAnswer.tags &&
                                    oneAnswer.tags.findIndex(
                                      (el) => el._id === option._id,
                                    ) >= 0
                                  "
                                />

                                {{ option.name }}

                                <ul
                                  v-if="!loadingSub && option.displaySubTags"
                                  :id="`${option._id}`"
                                  style="display: block; list-style: none"
                                >
                                  <li
                                    v-for="(subtag, index) in tagsList[i]
                                      .subTags"
                                    :key="index"
                                  >
                                    <input
                                      @click="
                                        handleSubTagClick(
                                          $event,
                                          option._id,
                                          subtag._id,
                                        )
                                      "
                                      type="checkbox"
                                      style="zoom: 1.4"
                                      :value="subtag._id"
                                      :id="`${index}`"
                                      :name="`${index}`"
                                      :checked="
                                        oneAnswer.subTags &&
                                        oneAnswer.subTags.findIndex(
                                          (el) => el._id === subtag._id,
                                        ) >= 0
                                      "
                                    />
                                    {{ subtag.name }}
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </b-dropdown-text>
                        </div>
                      </b-dropdown>

                      <div v-for="(tag, i) in oneAnswer.tags" :key="i">
                        <idx-chips>
                          {{ tag.name }}

                          <template v-if="myStatus !== 'respondido' && myStatus !== 'Resp. fora do prazo'">
                            <span
                              class="closebtn"
                              @click="handleRemoveTag(tag._id, i)"
                              >&times;</span
                            >
                          </template>
                        </idx-chips>

                        <template v-for="(subTag, index) in oneAnswer.subTags">
                          <idx-chips
                            v-if="subTag.mainTagId === oneAnswer.tags[i]._id"
                            :key="index"
                            :subTag="true"
                          >
                            <span>{{ subTag.name }}</span>

                            <template v-if="myStatus !== 'respondido' && myStatus !== 'Resp. fora do prazo'">
                              <span
                                class="closebtn"
                                @click="
                                  handleRemoveSubTag(tag._id, subTag._id, index)
                                "
                                >&times;</span
                              >
                            </template>
                          </idx-chips>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </idx-card>

              <div class="row mt-4 mb-4">
                <div class="col-12">
                  <idx-card
                    :title="`${this.$t(
                      'answers.answersDetails.treatments.changeStatus',
                    )}`"
                  >
                    <p>
                      {{ $t('answers.answersDetails.treatments.status') }}
                      :
                    </p>
                    <b-form-select
                      v-model="myStatus"
                      :options="status"
                      @change="changeStatus"
                      :disabled="disableStatus()"
                    >
                    </b-form-select>
                  </idx-card>
                </div>
              </div>

              <div class="mt-3 text-right">
                <button
                  @click="addNewComment"
                  class="btn btn-primary"
                  :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado' || myStatus === 'Resp. fora do prazo'"
                >
                  {{ $t('answers.answersDetails.treatments.send') }}
                  <font-awesome-icon :icon="['fas', 'paper-plane']" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <idx-card
            :title="`${this.$t('answers.answersDetails.treatments.feed')}`"
            :showFilters="true"
          >
            <feed-item :items="costumerNotifications" />
          </idx-card>
        </div>
      </div>
      <div
        v-if="
          userAuth.companyId === '5e18ccd0dc36a60022491bdf' ||
          userAuth.companyId === '61965aa04be7ea63c8f83435' ||
          userAuth.companyId === '5eea25739b8df13f10e8da40'
        "
      >
        <div style="display: flex">
          <div>
            <p><strong>{{$t('answers.answersDetails.treatments.enterContact')}}</strong></p>
            <div>
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-1"
                  v-model="contactClient"
                  :aria-describedby="ariaDescribedby"
                  name="radio-options"
                  :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado' || myStatus === 'Resp. fora do prazo'"
                >
                  <b-form-radio value="true">{{$t('answers.answersDetails.treatments.yes')}}</b-form-radio>
                  <b-form-radio value="false">{{$t('answers.answersDetails.treatments.no')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div>
          <div style="margin-left: 25px">
            <p><strong>{{$t('answers.answersDetails.treatments.whatChannel')}}</strong></p>
            <div>
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-2"
                  v-model="contactMode"
                  :aria-describedby="ariaDescribedby"
                  :disabled="disabledContactMode"
                  name="radio-sub-component"
                >
                  <b-form-radio value="whatsapp">{{$t('answers.answersDetails.treatments.wpp')}}</b-form-radio>
                  <b-form-radio value="telefone">{{$t('answers.answersDetails.treatments.phone')}}</b-form-radio>
                  <b-form-radio value="email">{{$t('answers.answersDetails.treatments.email')}}</b-form-radio>
                  <b-form-radio value="pessoalmente">{{$t('answers.answersDetails.treatments.personally')}}</b-form-radio>
                  <b-form-radio value="outros">{{$t('answers.answersDetails.treatments.others')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div>
        </div>
        <!-- <div class="row col-12 mt-3">
          <p class="idx-bold">
            {{$t('answers.answersDetails.treatments.caseDifficult')}}
          </p>
        </div>
        <div class="row mt-3">
          <div
            v-for="field in additionalFields"
            :key="field.name"
            class="col-3"
          >
            <p class="idx-bold">{{ field.name }}</p>
            <div class="row col-12">
              <input
                v-model.trim="field.value1"
                type="text"
                class="form-control"
                :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado'"
              />
            </div>
            <div class="row col-12 mt-2">
              <input
                v-model.trim="field.value2"
                type="text"
                class="form-control"
                :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado'"
              />
            </div>
            <div class="row col-12 mt-2">
              <input
                v-model.trim="field.value3"
                type="text"
                class="form-control"
                :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado'"
              />
            </div>
          </div>
        </div> -->
        <div class="row col-9 save-info-area">
          <button
            @click="saveAdditionalFields"
            class="btn btn-outline-primary mt-3"
            :disabled="myStatus === 'respondido' || myStatus === 'Hot Alert Validado' || myStatus === 'Resp. fora do prazo'"
          >
            {{$t('answers.answersDetails.treatments.saveInfo')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import IdxCard from '@/components/molecules/idx-card';
import idxChips from '@/components/molecules/idx-chips';
import FeedItem from '@/components/molecules/treatment-feed-item';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mapActions, mapState } from 'vuex';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  components: { IdxCard, FeedItem, VuePerfectScrollbar, idxChips },

  data: () => ({
    enabledAttach: false,
    filesToUpload: [],
    isLoading: false,
    myStatus: null,
    status: [],
    myResponsible: null,
    myComment: null,
    userAuth: null,
    loading: true,
    additionalFields: [
      {
        name: 'Número da peça',
        value1: null,
        value2: null,
        value3: null,
      },
      {
        name: 'Nome da peça',
        value1: null,
        value2: null,
        value3: null,
      },
      {
        name: 'Preço',
        value1: null,
        value2: null,
        value3: null,
      },
    ],
    contactClient: false,
    contactMode: null,
    disabledContactMode: false,
    users: [{ value: 'none', text: 'Ninguém' }],
    options: [],
    tagSearch: '',
    loadingSub: false,
    answerTags: [],
    profiles: [],
    userType: null,
    isSinqia: false,
  }),

  watch: {
    myStatus: function watchMyStatus() {
      if (this.myStatus === 'respondido' || this.myStatus === 'Hot Alert Validado' || this.myStatus === 'Resp. fora do prazo') {
        this.disabledContactMode = true;
      } else if (this.contactClient !== 'false') {
        this.disabledContactMode = false;
      }

      if (
        this.myStatus !== this.oneAnswer.treatments.status &&
        this.myStatus !== 'reaberto'
      ) {
        this.status = this.status.filter(function removeReopen(el) {
          return el.value !== 'reaberto';
        });
      }
    },
    'oneAnswer.treatments.enableMonitor': function watchEnableMonitor(value) {
      this.updateEnableMonitor({
        token: this.userAuth.token,
        answerId: this.oneAnswer._id,
        data: { enableMonitor: value },
      });
    },
    contactClient: async function watchContactClient() {
      if (this.contactClient === 'false') {
        this.contactMode = null;
        this.disabledContactMode = true;
      } else {
        this.disabledContactMode = false;
      }

      await api.put(
        `treatments/contact-client/${this.oneAnswer._id}`,
        {
          contactClient: this.contactClient,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    contactMode: async function watchContactClient() {
      await api.put(
        `treatments/contact-client/${this.oneAnswer._id}`,
        {
          contactClient: this.contactClient,
          contactMode: this.contactMode,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    filesToUpload: async function watchFileToUpload(arrayFiles) {
      if (arrayFiles.length > 5) {
        swal({
          title: this.$t(
            'answers.answersDetails.treatments.swExceededQuantity.title',
          ),
          text: this.$t(
            'answers.answersDetails.treatments.swExceededQuantity.description',
          ),
          icon: 'error',
        });
        this.$refs.fileupload.reset();
      }
    },

    '$i18n.locale': function watchLocale() {
      this.changeLabels();
    },
  },

  async created(){
    EventBus.$on('update-feed', async (order, optionValue) => {
        await this.setCostumerNotifications({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        answerId: this.oneAnswer._id,
        order,
        optionValue
      });
    });
  },

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getProfiles();

    await this.getStatus();

    this.myStatus = this.oneAnswer.treatments.status;

    await this.getUsersAction();

    await this.getAnswerTag();

    const siqiaIds = [
      '611cf4a2b072b92103fb492c',
      '61df3295564a28779efa96ef',
      '615e1e84f3614a0cdde347a5',
      '615e1d7edda6910cf7f30a12',
      '62eaf03c846efa152e408245',
      '630f9b68ac0bd055b424f634',
    ];
    const currentCompany = this.userAuth.companyId;

    if (siqiaIds.includes(currentCompany)) {
      this.isSinqia = true;
    } else {
      this.isSinqia = false;
    }

    this.myResponsible = this.oneAnswer.treatments.responsible
      ? this.oneAnswer.treatments.responsible
      : 'none';

    EventBus.$on('changeResponsible', (value) => {
      this.myResponsible = value;
    });

    await this.getAllUsers({
      userId: this.userAuth._id,
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
      params: {
        ih1: this.oneAnswer.ih1,
        ih2: this.oneAnswer.ih2,
      },
    });

    await this.setCostumerNotifications({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
      answerId: this.oneAnswer._id,
      order: 'latest'
    });

    if (this.oneAnswer.additionalFields) {
      if (this.oneAnswer.additionalFields.length > 0) {
        this.additionalFields = this.oneAnswer.additionalFields;
      }
    }

    if (this.oneAnswer.contactClient) {
      this.contactClient = this.oneAnswer.contactClient;
    }

    if (this.oneAnswer.contactMode) {
      this.contactMode = this.oneAnswer.contactMode;
    }

    if (this.contactClient === false) {
      this.disabledContactMode = true;
    } else {
      this.disabledContactMode = false;
    }

    this.changeLabels();

    this.loading = false;
  },

  computed: {
    ...mapState('treatments', ['costumerNotifications', 'oneAnswer']),
    ...mapState('settings', ['companyAllUsers']),
    ...mapState('actions', ['action']),
    ...mapState('authentication', ['userProfile']),

    tagsList() {
      return this.options.filter((option) => {
        return option.name.toLowerCase().includes(this.tagSearch.toLowerCase());
      });
    },
  },

  methods: {
    ...mapActions('treatments', [
      'setCostumerNotifications',
      'updateStatus',
      'updateStatusSinqia',
      'updateEnableMonitor',
      'setOneAnswer',
      'addComment',
      'updateResponsible',
    ]),
    ...mapActions('settings', ['getAllUsers']),

    changeLabels(){
      this.additionalFields[0].name = this.$t('answers.answersDetails.treatments.pieceNumber');
      this.additionalFields[1].name = this.$t('answers.answersDetails.treatments.pieceName');
      this.additionalFields[2].name = this.$t('answers.answersDetails.treatments.price');
    },

    async getProfiles() {
      const response = await api.get(
        `/profiles/treatments/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      response.data.forEach((el) => {
        this.profiles.push({ _id: el._id, name: el.name, type: el.type });
      });

      for (let i = 0; i < this.profiles.length; i += 1) {
        if (this.profiles[i]._id === this.userAuth.profileId) {
          this.userType = this.profiles[i].type;
        }
      }
    },

    disableStatus() {
      let profile = null;

      for (let i = 0; i < this.profiles.length; i += 1) {

        if (this.profiles[i]._id.toString() === this.userAuth.profileId.toString()) {
          profile = this.profiles[i].name;
        }
      }

      if (profile !== "Admin") {
    if (
      this.myStatus === "respondido" ||
      (this.myStatus === "Resp. fora do prazo" && !this.userProfile.permissions.treatments.statusClosed)
    ) {
      return true;
    }

    if (this.myStatus === "expirado" && !this.userProfile.permissions.treatments.statusClosed) {
      return true;
    }

    if (this.myStatus === "Hot Alert Validado") {
      return true;
    }
  }

      return false;
    },

    async handleRemoveSubTag(tagId, subTagId, subTagIndex) {
      this.oneAnswer.subTags.splice(subTagIndex, 1);

      await api.patch(
        `/tag-subtag/${this.oneAnswer._id}`,
        {
          subTagId,
          tagId,
          operation: 'delete',
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async handleRemoveTag(tagId, tagIndex) {
      swal({
        title: `${this.$t('tagsTreatmenTranslateUpdate.removeTagTitle')}`,
        text: `${this.$t('tagsTreatmenTranslateUpdate.describe')}`,
        icon: 'warning',
        buttons: [this.$t('answers.cancel'), this.$t('answers.remove')],
        dangerMode: true,
      }).then(async (deleted) => {
        if (deleted) {
          swal('Tag removida com sucesso!', {
            icon: 'success',
          });
          this.oneAnswer.tags.splice(tagIndex, 1);
          const subTags = [];
          this.oneAnswer.subTags.forEach((el) => {
            if (el.mainTagId !== tagId) {
              subTags.push(el);
            }
          });
          this.oneAnswer.subTags = subTags;
          await api.patch(
            `/answer-tags/${this.oneAnswer._id}`,
            {
              operation: 'delete',
              tagId,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
        }
      });
    },

    async handleSubTagClick(event, tagId, subTagId) {
      let operation = null;

      const tagIndex = this.options.findIndex((el) => el._id === tagId);

      const tag = this.options[tagIndex];

      const subTagIndex = tag.subTags.findIndex((el) => el._id === subTagId);

      const subTag = tag.subTags[subTagIndex];

      if (event.target.checked === true) {
        operation = 'add';
      } else {
        operation = 'delete';
      }

      if (event.target.checked === true) {
        const index = this.oneAnswer.tags.findIndex((el) => el._id === tag._id);

        if (index < 0) {
          this.oneAnswer.tags.push(tag);
        }

        this.oneAnswer.subTags.push(subTag);
      } else {
        const index = this.oneAnswer.subTags.findIndex(
          (el) => el._id === subTag._id,
        );

        if (index >= 0) {
          this.oneAnswer.subTags.splice(index, 1);
        }
      }

      this.loadingSub = true;

      await api.patch(
        `/tag-subtag/${this.oneAnswer._id}`,
        {
          subTagId: subTag._id,
          tagId: tag._id,
          operation,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.loadingSub = false;
    },

    async handleTagClick(event, tagId) {
      const tagIndex = this.options.findIndex((el) => el._id === tagId);

      const tag = this.options[tagIndex];

      if (event.target.checked === true) {
        this.oneAnswer.tags.push(tag);

        await api.patch(
          `/answer-tags/${this.oneAnswer._id}`,
          {
            operation: 'add',
            tagId: event.target.value,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      } else {
        const foundIndex = this.oneAnswer.tags.findIndex(
          (el) => el._id === tag._id,
        );

        if (foundIndex >= 0) {
          this.oneAnswer.tags.splice(foundIndex, 1);
        }

        const response = await api.patch(
          `/answer-tags/${this.oneAnswer._id}`,
          {
            operation: 'delete',
            tagId: event.target.value,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        this.oneAnswer.subTags = response.data.subTags;
      }
    },

    async showSubTags(event, tagId, tagsListIndex) {
      this.tagsList[tagsListIndex].displaySubTags =
        !this.tagsList[tagsListIndex].displaySubTags;

      if (this.tagsList[tagsListIndex].displaySubTags) {
        event.target.classList.remove('fa-caret-right');
        event.target.classList.add('fa-caret-down');
      } else {
        event.target.classList.remove('fa-caret-down');
        event.target.classList.add('fa-caret-right');
      }

      this.loadingSub = true;

      const response = await api.get(`/subtags/${tagId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.tagsList[tagsListIndex].subTags = response.data;

      this.loadingSub = false;
    },

    async getAnswerTag() {
      try {
        const response = await api.get('/tags', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            tagGroup: this.tagGroupId,
            actionId: this.oneAnswer.actionId._id,
          },
        });

        this.answerTags = response.data;
        this.options = this.answerTags;

        this.options.forEach((element) => {
          element.displaySubTags = false;
          element.subTags = [];
          element.loading = false;
        });
      } catch (error) {
        window.console.log(error);
      }
    },

    removeFile(index) {
      this.filesToUpload.splice(index, 1);
    },
    async getUsersAction() {
      const response = await api.get(
        `/users-action/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.oneAnswer.actionId._id,
            answerId: this.oneAnswer._id,
          },
        },
      );

      response.data.listUsers.map((el) => {
        if (el.treatmentsResponsible || el.treatmentsResponsible === null) {
          this.users.push({
            value: el._id,
            text: el.name,
          });
        }
      });

      const res = await api.get(`company/${this.userAuth.companyId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.enabledAttach = res.data.enableAttachTreatments || false;
    },

    async addNewComment() {
      if (this.myComment || this.filesToUpload) {
        try {
          if (this.filesToUpload) {
            if (
              this.filesToUpload.filter((item) => item.size > 10000000).length
            ) {
              window.console.log('muito grande');
              swal({
                title: this.$t(
                  'answers.answersDetails.treatments.swAddError.title',
                ),
                text: 'Um ou mais arquivos excedem o limite. O tamanho máximo permitido é 10Mb',
                icon: 'error',
              });
              this.$refs.fileupload.reset();
            } else {
              this.isLoading = true;

              const fileLinks = [];

              // eslint-disable-next-line no-restricted-syntax
              for (const file of this.filesToUpload) {
                const formData = new FormData();
                formData.append('file', file);
                // eslint-disable-next-line no-await-in-loop
                const link = await api.post(
                  'treatments/attachments',
                  formData,
                  {
                    headers: {
                      'x-access-token': this.userAuth.token,
                      'Content-Type': 'multipart/form-data',
                    },
                  },
                );
                fileLinks.push(link.data);
              }

              this.isLoading = false;
              await this.addComment({
                token: this.userAuth.token,
                answerId: this.oneAnswer._id,
                data: {
                  comment: this.myComment || '',
                  attachments: fileLinks,
                },
              });
              swal({
                title: this.$t('answers.answersDetails.treatments.swAdd.title'),
                text: this.$t(
                  'answers.answersDetails.treatments.swAdd.description',
                ),
                icon: 'success',
              });
              this.setCostumerNotifications({
                token: this.userAuth.token,
                companyId: this.userAuth.companyId,
                answerId: this.oneAnswer._id,
                order: 'latest'
              });
              this.filesToUpload = [];
            }
          } else if (this.myComment && this.myComment !== '') {
            await this.addComment({
              token: this.userAuth.token,
              answerId: this.oneAnswer._id,
              data: { comment: this.myComment },
            });
            swal({
              title: this.$t('answers.answersDetails.treatments.swAdd.title'),
              text: this.$t(
                'answers.answersDetails.treatments.swAdd.description',
              ),
              icon: 'success',
            });
            this.setCostumerNotifications({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              answerId: this.oneAnswer._id,
              order: 'latest'
            });
          }
        } catch (error) {
          swal({
            title: this.$t(
              'answers.answersDetails.treatments.swAddError.title',
            ),
            text: this.$t(
              'answers.answersDetails.treatments.swAddError.description',
            ),
            icon: 'error',
          });
        }
      }

      this.myComment = null;
    },

    async saveAdditionalFields() {
      try {
        await api.put(
          `treatments/additional-fields/${this.oneAnswer._id}`,
          {
            additionalFields: this.additionalFields,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        swal({
          title: this.$t('answers.answersDetails.treatments.swSave.title'),
          text: this.$t('answers.answersDetails.treatments.swSave.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('answers.answersDetails.treatments.swAddError.title'),
          text: error.response.data.message,
          icon: 'error',
        });
      }
    },

    changeResponsible() {
      this.updateResponsible({
        token: this.userAuth.token,
        answerId: this.oneAnswer._id,
        data: { responsible: this.myResponsible },
      }).then(() => {
        if (this.userAuth._id !== this.myResponsible) {
          swal({
            title: this.$t(
              'answers.answersDetails.treatments.swResponsible.title',
            ),
            text: this.$t(
              'answers.answersDetails.treatments.swResponsible.description',
            ),
            icon: 'success',
          });
        }

        this.oneAnswer.treatments.responsible = this.myResponsible;

        this.setCostumerNotifications({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.oneAnswer._id,
          order: 'latest'
        });
      });
    },

    async changeStatus() {
      if (this.myComment) {
        this.addNewComment();
      }

      if (
        this.oneAnswer.actionId.resurveyId &&
        this.myStatus === 'respondido' || this.myStatus === 'Resp. fora do prazo'
      ) {
        const response = await api.get(
          `/resurvey/${this.oneAnswer.actionId.resurveyId}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        const hasResurvey = response.data.resurveyGrades.findIndex(
          (el) => el.grade === this.oneAnswer.review && el.value === true,
        );

        if (hasResurvey >= 0) {
          if (this.oneAnswer.anonymousResponse !== true) {
            // mercedes
            if (
              this.userAuth.companyId === '5e18ccd0dc36a60022491bdf' ||
              this.userAuth.companyId === '61965aa04be7ea63c8f83435'
            ) {
              if (this.contactClient === 'true') {
                swal({
                  title: this.$t('treatments.resurveyWarning.title'),
                  text: this.$t('treatments.resurveyWarning.description'),
                  icon: 'warning',
                  buttons: [
                    this.$t('treatments.resurveyWarning.cancelButton'),
                    this.$t('treatments.resurveyWarning.saveButton'),
                  ],
                  dangerMode: true,
                }).then(async (yes) => {
                  if (yes) {
                    await this.updateStatusProcess(this.myComment);
                  } else {
                    this.myStatus = this.oneAnswer.treatments.status;
                  }
                });
              } else {
                await this.updateStatusProcess(this.myComment);
              }
            } else {
              swal({
                title: this.$t('treatments.resurveyWarning.title'),
                text: this.$t('treatments.resurveyWarning.description'),
                icon: 'warning',
                buttons: [
                  this.$t('treatments.resurveyWarning.cancelButton'),
                  this.$t('treatments.resurveyWarning.saveButton'),
                ],
                dangerMode: true,
              }).then(async (yes) => {
                if (yes) {
                  await this.updateStatusProcess(this.myComment);
                } else {
                  this.myStatus = this.oneAnswer.treatments.status;
                }
              });
            }
          } else {
            await this.updateStatusProcess(this.myComment);
          }
        } else {
          await this.updateStatusProcess(this.myComment);
        }
      } else {
        await this.updateStatusProcess(this.myComment);
      }

      this.oneAnswer.treatments.status = this.myStatus;
      this.getStatus();
    },

    async updateStatusProcess(comment) {
      try {
        if (this.isSinqia) {
          await this.updateStatusSinqia({
            token: this.userAuth.token,
            answerId: this.oneAnswer._id,
            data: { status: this.myStatus, type: this.userType, comment },
          });
        } else {
          await this.updateStatus({
            token: this.userAuth.token,
            answerId: this.oneAnswer._id,
            data: { status: this.myStatus, type: this.userType },
          });
        }

        if (comment) {
          swal({
            title: 'Sucesso!',
            text: `Seu status foi alterado para ${this.myStatus}! Seu comentário e status foram registrados no feed.`,
            icon: 'success',
          });
        } else {
          swal({
            title: this.$t('answers.answersDetails.treatments.swStatus.title'),
            text: `${this.$t(
              'answers.answersDetails.treatments.swStatus.description',
            )} ${this.myStatus}.`,
            icon: 'success',
          });
        }

        this.setCostumerNotifications({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.oneAnswer._id,
          order: 'latest'
        });
      } catch (error) {
        if (this.isSinqia) {
          this.myStatus = this.oneAnswer.treatments.status;
          swal('Oops!', error.response.data.message, 'error');
        } else {
          swal('Oops!', this.$t('genericMessages.error.description'), 'error');
        }
      }
    },

    // checkDisabledContactMode() {
    //   return this.disabledContactMode || this.myStatus === 'respondido';
    // },

    async getStatus() {
      this.status = [];

      const response = await api.get('/treatments/status', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          lang: this.$i18n.locale,
        },
      });

      let profile = null;

      for (let i = 0; i < this.profiles.length; i += 1) {
        if (this.profiles[i]._id === this.userAuth.profileId) {
          profile = this.profiles[i].name;
        }
      }

      if(profile !== 'Admin') {
        this.status = response.data.filter(
          (status) => status.value !== 'Hot Alert Validado'
        )
      } else {
        this.status = response.data;
      }

      if (this.oneAnswer.treatments.status === 'expirado') {
        this.status.push(
          {
            text: 'Reaberto',
            value: 'reaberto',
          },
          {
            text: 'Expirado',
            value: 'expirado',
            disabled: true,
          },
        );
      }

      if (this.oneAnswer.treatments.status === 'Resp. fora do prazo') {
        this.status.push(
          {
            text: 'Resp. fora do prazo',
            value: 'Resp. fora do prazo',
            disabled: true,
          }
        )
      }

      this.status = this.status.filter((item) => item.value !== 'Resp. Fora do prazo');
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-eraser-tag {
  margin-left: -4px;
  margin-top: -4px;
}

.input-search-tags {
  width: 70%;
  margin-top: 10px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-left: 20px;
}

.comment-area {
  display: flex;
  flex-direction: row;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 415px;
}

.save-info-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 185px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/treatments/treatment-details/treatments/index.vue